import React, { useState, useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import {
  LDS_AUTOCMPLETE_CITIES,
  LDS_AUTOCOMPLETE_MORE,
} from "../../../../../assets/Data/LdsAirportsAutocomplete";
import {
  DYNAMIC_PACKAGES,
  PLANES,
  useSearch,
} from "../../../../../contexts/SearchContext";

function dealTypeForLdsAutocomplete(searchTab) {
  if (searchTab === DYNAMIC_PACKAGES || searchTab === PLANES) return "Flights";
  return searchTab;
}
import { parseLocationToString } from "../AutoCompleteInput/autocompleteinputLDS";
import "./MobileDestinationPicker.css";

function getFlagUrl(countryCode) {
  if (!countryCode) return null;
  return `https://flagcdn.com/w20/${countryCode.toLowerCase()}.png`;
}

function MobileDestinationPicker({ onSelect, onClose }) {
  const { categories, destinations, searchTab } = useSearch();
  const [cities, setCities] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const searchInputRef = useRef(null);

  useEffect(() => {
    const st = dealTypeForLdsAutocomplete(searchTab);
    const list = destinations
      .filter(
        (dest) =>
          dest.dealType === st &&
          (categories.length === 0 ||
            (categories.includes("ALL") &&
              (dest.subject === "ALL" || !dest.subject)) ||
            categories.includes(dest.subject))
      )
      .map((city) => {
        const hebCity = LDS_AUTOCMPLETE_CITIES.find(
          (ldsCity) => ldsCity.AIRPORTCODE === city.destCity
        );
        return {
          COUNTRYNAME_HEB: hebCity?.COUNTRYNAME_HEB || city.destCountryName,
          CITYNAME_HEB: hebCity?.CITYNAME_HEB || city.destCountryName,
          AIRPORTCODE: city.destCity,
          AIRPORTNAME: hebCity?.AIRPORTNAME || "",
          CITYCODE: city.destCity,
          CITYNAME: city.destCityName,
          COUNTRYCODE: hebCity?.COUNTRYCODE || "",
          COUNTRYNAME: city.destCountryName,
        };
      });

    const hebCities = list.reduce((acc, city) => {
      if (!acc.find((c) => c.CITYCODE === city.CITYCODE)) acc.push(city);
      return acc;
    }, []);

    if (searchTab !== DYNAMIC_PACKAGES && searchTab !== PLANES) {
      for (let i = 0; i < LDS_AUTOCOMPLETE_MORE.length; i++) {
        hebCities.unshift(LDS_AUTOCOMPLETE_MORE[i]);
      }
    }
    setCities(hebCities);
  }, [searchTab, categories, destinations]);

  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, []);

  useEffect(() => {
    const t = setTimeout(() => {
      if (searchInputRef.current) {
        const el = searchInputRef.current;
        if (el.focus) el.focus();
      }
    }, 100);
    return () => clearTimeout(t);
  }, []);

  const filterValue = searchQuery ? searchQuery.toLowerCase().trim() : "";
  const filteredCities = cities.filter((city) => {
    if (!filterValue) return true;
    return Object.values(city).some((val) =>
      val ? String(val).toLowerCase().includes(filterValue) : false
    );
  });

  const handleSelect = (optionData) => {
    onSelect(optionData);
    onClose();
  };

  const content = (
    <div className="mobile-destination-picker" role="dialog" aria-modal="true" aria-labelledby="mobile-destination-picker-title">
      <header className="mobile-destination-picker-header">
        <button
          type="button"
          className="mobile-destination-picker-close"
          onClick={onClose}
          aria-label="סגור"
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>
        <h2 id="mobile-destination-picker-title" className="mobile-destination-picker-title">
          בחר יעד
        </h2>
        <input
          ref={searchInputRef}
          type="text"
          className="mobile-destination-picker-search"
          placeholder="חיפוש יעד..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          aria-label="חיפוש יעד"
        />
      </header>
      <div className="mobile-destination-picker-body">
        {filteredCities.map((city) => {
          const flagUrl = getFlagUrl(city.COUNTRYCODE);
          const label =
            city.CITYCODE === "ALL"
              ? `${city.COUNTRYNAME_HEB || ""} - ${city.COUNTRYNAME || ""}`
              : city.CITYNAME_HEB && city.COUNTRYNAME_HEB
                ? `(${city.AIRPORTCODE}) ${city.COUNTRYNAME_HEB} - ${city.CITYNAME_HEB}`
                : `${city.CITYNAME || ""} - ${city.COUNTRYNAME || ""}`;
          return (
            <button
              key={city.CITYCODE || city.AIRPORTCODE || label}
              type="button"
              className="mobile-destination-picker-item"
              onClick={() => handleSelect(city)}
            >
              {flagUrl && (
                <img
                  src={flagUrl}
                  alt=""
                  className="mobile-destination-picker-flag"
                  onError={(e) => {
                    e.target.style.display = "none";
                  }}
                />
              )}
              <span className="mobile-destination-picker-item-label">{label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );

  return typeof document !== "undefined"
    ? createPortal(content, document.body)
    : content;
}

export default MobileDestinationPicker;
